import { MFA_ANALYTICS_EVENTS } from '@shipstation/client-common/mfa/mfa-constants';

import type { MfaTracker } from '@shipstation/client-common/mfa/mfa-platform';
import { Segment } from '../../../services/analytics-services/segment';

/**
 * Segment dashboards key off `source`, and `source` defaults to `''` inside the
 * client-common modal. The adapter records the source it last handed to the modal so a
 * dropped or defaulted `source` still lands on the right dashboard row.
 */
let activeMfaSource = '';

export const setActiveMfaAnalyticsSource = (source: string): void => {
  activeMfaSource = source;
};

/**
 * ss-ui-client implementation of the client-common `MfaTracker` seam.
 * Injected via `configureMfaTracker` so client-common never imports Segment.
 */
export const ssUiClientMfaTracker: MfaTracker = (event, props) => {
  Segment.trackEvent(event, { ...props, source: props.source || activeMfaSource });
};

type MfaTrackingParams = {
  /** request url the mfa-required error came from, or a USER_ACTIONS feature name */
  source: string;
};

export const trackMfaPasswordChallenge = (params: MfaTrackingParams): void => {
  ssUiClientMfaTracker(MFA_ANALYTICS_EVENTS.passwordChallenge, params);
};

export const trackMfaCodeChallenge = (params: MfaTrackingParams): void => {
  ssUiClientMfaTracker(MFA_ANALYTICS_EVENTS.codeChallenge, params);
};

export const trackMfaSuccess = (params: MfaTrackingParams): void => {
  ssUiClientMfaTracker(MFA_ANALYTICS_EVENTS.success, params);
};
